/**
 * A BE válaszából elfedi a különböző data kulcsoat, és egységes objektumot ad vissza.
 * @author laci on 2016.12.06.
 */
export default function parseResponse(response, returnProperty) {
	var data = response.data;

	// TODO:  megvizsgálni, hogy kell-e egyáltalán ez a "kitaláljuk, hogy mi a kulcs" dolog,
	// TODO: lehet, hogy elég lenne csak azokat automatikusan itemmé alakítani, amiket ismerünk.
	if (!returnProperty) {
		// then searching for a possible return property object
		var responseDataKeys = [];
		if (angular.isObject(data)) {
			responseDataKeys = Object.keys(data);
		}

		for (var i = 0; i < responseDataKeys.length; i++) {
			var key = responseDataKeys[i];
			var possibleResponseObject = data[key];

			// _result is the count number, not the object we are looking for
			if (key != '_results') {
				if (angular.isObject(possibleResponseObject) || angular.isArray(possibleResponseObject)) {
					// if it is an object or array, we've found the droids :)
					returnProperty = key;
					break;
				}

				// didn't found better, so...
				returnProperty = key;
			}
		}
	}

	if (data[returnProperty]) {
		response.items = data[returnProperty];
	}

	// when result is filtered, then we got the count of the all items
	if (data._results) {
		response.count = data._results;
	}
}
